if (!window.KROWN_SOIL_GENIE_RULES) {
  window.KROWN_SOIL_GENIE_RULES = {
    MY_SOIL_VARIANT_ID: 48455285473499,
    SHIPBOB_VARIANT_ID: 48549425676507
  };
}

if (!window.soilGenieCartRules) {
  window.soilGenieCartRules = (() => {
    const { MY_SOIL_VARIANT_ID, SHIPBOB_VARIANT_ID } = window.KROWN_SOIL_GENIE_RULES;
    const SPECIAL_VARIANT_IDS = [MY_SOIL_VARIANT_ID, SHIPBOB_VARIANT_ID];
    const CART_ITEM_SELECTOR = '#AjaxCartForm [data-js-cart-item]';

    const isSpecialVariant = variantId => SPECIAL_VARIANT_IDS.includes(Number(variantId));

    const fetchJSON = async (url, options = {}) => {
      const response = await fetch(url, options);
      return response.json();
    };

    const getCartFromDom = () => {
      const cartItems = document.querySelectorAll(CART_ITEM_SELECTOR);

      if (!cartItems.length) {
        return null;
      }

      return {
        items: Array.from(cartItems).map(item => ({
          variant_id: Number(item.dataset.variantId),
          quantity: Number(item.dataset.qty || 0),
          line: Number(item.dataset.line)
        }))
      };
    };

    const getCart = async ({ preferDom = true } = {}) => {
      if (preferDom) {
        const cartFromDom = getCartFromDom();
        if (cartFromDom) {
          return cartFromDom;
        }
      }

      return fetchJSON(`${KROWN.settings.routes.cart_url}.js`);
    };

    const getVariantQuantity = (cart, variantId) => {
      return cart.items.reduce((total, item) => {
        return item.variant_id === variantId ? total + item.quantity : total;
      }, 0);
    };

    const getSpecialQuantity = cart => {
      return SPECIAL_VARIANT_IDS.reduce((total, variantId) => total + getVariantQuantity(cart, variantId), 0);
    };

  const cartHasOtherItems = cart => {
  return cart.items.some(item => {

    // 🧠 If bundle → treat as "has other items"
    if (item.has_components) {
      return true;
    }

    // normal products
    return !isSpecialVariant(item.variant_id);
  });
};

    const syncSpecialVariant = async (cart, desiredVariantId) => {
      const totalSpecialQuantity = getSpecialQuantity(cart);

      if (!totalSpecialQuantity) {
        return cart;
      }

      const mySoilQuantity = getVariantQuantity(cart, MY_SOIL_VARIANT_ID);
      const shipBobQuantity = getVariantQuantity(cart, SHIPBOB_VARIANT_ID);
      const alreadySynced =
        (desiredVariantId === MY_SOIL_VARIANT_ID && mySoilQuantity === totalSpecialQuantity && shipBobQuantity === 0) ||
        (desiredVariantId === SHIPBOB_VARIANT_ID && shipBobQuantity === totalSpecialQuantity && mySoilQuantity === 0);

      if (alreadySynced) {
        return cart;
      }

      return fetchJSON(`${KROWN.settings.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          updates: {
            [MY_SOIL_VARIANT_ID]: desiredVariantId === MY_SOIL_VARIANT_ID ? totalSpecialQuantity : 0,
            [SHIPBOB_VARIANT_ID]: desiredVariantId === SHIPBOB_VARIANT_ID ? totalSpecialQuantity : 0
          }
        })
      });
    };

    const normalizeCart = async (options = {}) => {
      const cart = await getCart(options);
      if (!getSpecialQuantity(cart)) {
        return cart;
      }

      const desiredVariantId = cartHasOtherItems(cart) ? SHIPBOB_VARIANT_ID : MY_SOIL_VARIANT_ID;
      return syncSpecialVariant(cart, desiredVariantId);
    };

    const normalizeSnapshot = cart => {
      return {
        items: cart.items
          .map(item => ({
            ...item,
            variant_id: Number(item.variant_id),
            quantity: Number(item.quantity || 0),
            line: Number(item.line)
          }))
          .filter(item => item.quantity > 0)
      };
    };

    const getDesiredVariantId = cart => {
      return cartHasOtherItems(cart) ? SHIPBOB_VARIANT_ID : MY_SOIL_VARIANT_ID;
    };

    const getCartWithLineQuantity = (cart, line, quantity) => {
      return normalizeSnapshot({
        items: cart.items.map(item => {
          if (Number(item.line) === Number(line)) {
            return {
              ...item,
              quantity
            };
          }

          return item;
        })
      });
    };

    const prepareForAdd = async incomingVariantId => {
      const variantId = Number(incomingVariantId);
      const cart = await getCart();

      if (!isSpecialVariant(variantId) && !getSpecialQuantity(cart)) {
        return variantId;
      }

      if (!isSpecialVariant(variantId) && getVariantQuantity(cart, MY_SOIL_VARIANT_ID) > 0) {
        return variantId;
      }

      if (isSpecialVariant(variantId)) {
        return getDesiredVariantId(cart);
      }

      return variantId;
    };

    const needsNormalizationAfterAdd = incomingVariantId => {
      const variantId = Number(incomingVariantId);
      const cart = getCartFromDom();

      if (!cart) {
        return isSpecialVariant(variantId);
      }

      if (isSpecialVariant(variantId)) {
        return cartHasOtherItems(cart);
      }

      return !isSpecialVariant(variantId) && getVariantQuantity(cart, MY_SOIL_VARIANT_ID) > 0;
    };

    const normalizeCartByLineChange = async (line, quantity) => {
      const cart = getCartFromDom();

      if (!cart) {
        return normalizeCart();
      }

      const nextCart = getCartWithLineQuantity(cart, line, quantity);

      if (!getSpecialQuantity(nextCart)) {
        return nextCart;
      }

      return syncSpecialVariant(nextCart, getDesiredVariantId(nextCart));
    };

    return {
      MY_SOIL_VARIANT_ID,
      SHIPBOB_VARIANT_ID,
      isSpecialVariant,
      normalizeCart,
      normalizeCartByLineChange,
      needsNormalizationAfterAdd,
      prepareForAdd
    };
  })();
}
